import React from "react";
import { FormattedMessage } from "react-intl";

import { ContentfulPhone } from "../../../ContentfulTypes";
import { CustomDisplayTag, DisplayTag } from "../styles";
import { DeviceType } from "../../../types";

interface Props {
  phone: ContentfulPhone
}

const PhoneDisplayTag = ({
  phone,
}: Props) => {
  const isPrepaidPhone = phone?.deviceType === DeviceType.PrepaidPhone;
  const isPostpaidPhone = phone?.deviceType === DeviceType.Phone;
  const displayTag = (isPrepaidPhone && phone?.displayTag) || (isPostpaidPhone && phone?.displayTag
    && phone?.smartFilters.some(
      (offer) => offer.cmsName === 'standard-offers-preOrderPhones',
    ));

  const customDisplayTag = (isPostpaidPhone && phone?.customDisplayTag);

  const hasStackableOffer = phone?.phoneVariants?.some(({
    onsiteBillCredit,
    onsiteAccessoriesCredit,
    bonusPcoPoints,
  }) => onsiteBillCredit ?? onsiteAccessoriesCredit ?? bonusPcoPoints);

  const displayLimitedTag = !isPrepaidPhone && hasStackableOffer;
  
  if (displayLimitedTag) {
    return (
      <CustomDisplayTag>
        <FormattedMessage id="LimitedTimeOffer" />
      </CustomDisplayTag>
    );
  }

  return (
    <>
      {/* Used to show Black Display Tag manually added from CMS (PREPAID PHONES ONLY) */}
      {displayTag && (
        <DisplayTag>
          {phone?.displayTag}
        </DisplayTag>
      )}
      {/* Used to show Red Display Tag manually added from CMS (POSTPAID PHONES ONLY) */}
      {customDisplayTag && (
        <CustomDisplayTag>
          {phone?.customDisplayTag}
        </CustomDisplayTag>
      )}
    </>
  );
};

export default PhoneDisplayTag;
